/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const propertyTransactionTypeEnum = {
    "SALE": "SALE",
    "RENTAL": "RENTAL",
    "LIFETIME_SALE": "LIFETIME_SALE",
    "AUCTION_SALE": "AUCTION_SALE",
    "OFF_PLAN_SALE": "OFF_PLAN_SALE"
} as const;

export type PropertyTransactionTypeEnum = (typeof propertyTransactionTypeEnum)[keyof typeof propertyTransactionTypeEnum];

/**
 * @description Type de transaction :\n- SALE : SALE\n- RENTAL : Location\n- LIFETIME_SALE : Viager\n- AUCTION_SALE : Vente aux enchères\n- OFF_PLAN_SALE : VEFA (vente en l\'état futur d\'achèvement)\n
*/
export type PropertyTransactionType = PropertyTransactionTypeEnum;